if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.stickyAddToCart = document.querySelector(".sticky-cart-bar-add-btn");
        this.stickyAddToCartLoading = document.querySelector(".sticky-cart-bar-add-btn .loading__spinner");
        this.stickyAddToCartQuantity = document.querySelector(".sticky-cart-bar-qty-input");
        this.stickyAddToCartText = document.querySelector(".sticky-cart-bar-add-btn span");
      }

      onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.stickyAddToCart?.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');
    this.stickyAddToCartLoading?.classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    
    // Collect active addon variant IDs
    const activeAddons = document.querySelectorAll('.addon-card .toggle.active');
    const addonItems = [];
    activeAddons.forEach((toggle) => {
        const variantId = toggle.dataset.variantId;
        if (variantId) {
            addonItems.push({
                id: variantId,
                quantity: 1
            });
        }
    });

    if (this.cart) {
        formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
    }

    // If there are active addons, we need to use a different approach
    if (addonItems.length > 0) {
        // Build items array including main product and addons
        const mainProductId = formData.get('id');
        const mainProductQuantity = formData.get('quantity') || 1;
        
        const items = [
            {
                id: parseInt(mainProductId),
                quantity: parseInt(mainProductQuantity)
            },
            ...addonItems.map(item => ({
                id: parseInt(item.id),
                quantity: item.quantity
            }))
        ];

        const jsonConfig = fetchConfig('javascript');
        jsonConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
        jsonConfig.headers['Content-Type'] = 'application/json';
        
        const bodyData = { items };
        
        if (this.cart) {
            bodyData.sections = this.cart.getSectionsToRender().map((section) => section.id);
            bodyData.sections_url = window.location.pathname;
        }
        
        jsonConfig.body = JSON.stringify(bodyData);

        fetch(`${routes.cart_add_url}`, jsonConfig)
            .then((response) => response.json())
            .then((response) => {
                // Handle array response from multiple items or error
                const hasError = Array.isArray(response) 
                    ? response.some(item => item.status) 
                    : response.status;
                
                if (hasError) {
                    const errorResponse = Array.isArray(response) 
                        ? response.find(item => item.status) 
                        : response;
                    
                    publish(PUB_SUB_EVENTS.cartError, {
                        source: 'product-form',
                        productVariantId: formData.get('id'),
                        errors: errorResponse.errors || errorResponse.description,
                        message: errorResponse.message,
                    });
                    this.handleErrorMessage(errorResponse.description);

                    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButtonText.classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;
                    return;
                } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                }

                const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                if (!this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'product-form',
                        productVariantId: formData.get('id'),
                        cartData: response,
                    }).then(() => {
                        CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                    });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                    document.body.addEventListener(
                        'modalClosed',
                        () => {
                            setTimeout(() => {
                                CartPerformance.measure("add:paint-updated-sections", () => {
                                    this.cart.renderContents(response);
                                });
                            });
                        },
                        { once: true }
                    );
                    quickAddModal.hide(true);
                } else {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                    });
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading__spinner').classList.add('hidden');
                this.stickyAddToCartLoading.classList.add('hidden');
                
                if(this.stickyAddToCartQuantity){
                    this.stickyAddToCartQuantity.value = 1;
                }

                CartPerformance.measureFromEvent("add:user-action", evt);
            });
    } else {
        // Original logic when no addons are selected
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    publish(PUB_SUB_EVENTS.cartError, {
                        source: 'product-form',
                        productVariantId: formData.get('id'),
                        errors: response.errors || response.description,
                        message: response.message,
                    });
                    this.handleErrorMessage(response.description);

                    const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                    if (!soldOutMessage) return;
                    this.submitButton.setAttribute('aria-disabled', true);
                    this.submitButtonText.classList.add('hidden');
                    soldOutMessage.classList.remove('hidden');
                    this.error = true;
                    return;
                } else if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                }

                const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                if (!this.error)
                    publish(PUB_SUB_EVENTS.cartUpdate, {
                        source: 'product-form',
                        productVariantId: formData.get('id'),
                        cartData: response,
                    }).then(() => {
                        CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                    });
                this.error = false;
                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                    document.body.addEventListener(
                        'modalClosed',
                        () => {
                            setTimeout(() => {
                                CartPerformance.measure("add:paint-updated-sections", () => {
                                    this.cart.renderContents(response);
                                });
                            });
                        },
                        { once: true }
                    );
                    quickAddModal.hide(true);
                } else {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                        this.cart.renderContents(response);
                    });
                }
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                this.submitButton.classList.remove('loading');
                this.stickyAddToCart?.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading__spinner').classList.add('hidden');
                this.stickyAddToCartLoading?.classList.add('hidden');
                if(this.stickyAddToCartQuantity){
                    this.stickyAddToCartQuantity.value = 1;
                }
                CartPerformance.measureFromEvent("add:user-action", evt);
            });
      }
    }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.stickyAddToCart?.setAttribute('disabled', 'disabled');
          if (text) { 
            this.submitButtonText.textContent = text;
            this.stickyAddToCartText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          this.stickyAddToCart?.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          if(this.stickyAddToCartText){
            this.stickyAddToCartText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
